import { Component, Inject, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import { MusicsDataService } from '../../providers/Table/musicsData.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-artist-pîcture-search',
  templateUrl: './artistPictureSearch.component.html',
  styleUrls: ['./artistPictureSearch.component.scss']
})
export class ArtistPictureSearch implements OnInit, AfterViewInit {

  deezerArtistPictureResults: any[] = [];

  spotifyArtistPictureResults: any[] = [];

  discogsArtistPictureResults: any[] = [];

  defaultRecordsByService: any = 5;

  pageEvent: any;

  loading = false;

  dataOut = {
    startRow: 0,
    endRow: 0,
    cover: '',
    edit: false
  };

  @ViewChild('searchInput') searchInput;

  constructor(private musicsDataService: MusicsDataService,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              @Inject(MAT_DIALOG_DATA) private dataIn,
              private dialogRef: MatDialogRef<any>) {
    iconRegistry.addSvgIcon('close', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/close.svg'));
  }

  ngOnInit() {
    this.dataOut.startRow = this.dataIn.startRow;
    this.dataOut.endRow = this.dataIn.endRow;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchInput.nativeElement.value = this.dataIn.search;
      this.searchArtistPicture(this.dataIn.search);
    });
  }

  searchArtistPicture(search) {
    this.deezerArtistPictureResults = [];
    this.spotifyArtistPictureResults = [];
    if (search && search.length > 0) {
      this.loading = true;
      this.musicsDataService.searchArtistPicture(search)
        .then(res => {
          console.log(res);
          this.loading = false;
          this.deezerArtistPictureResults = res.deezer.slice(0, this.defaultRecordsByService);
          this.spotifyArtistPictureResults = res.spotify.slice(0, this.defaultRecordsByService);
          this.discogsArtistPictureResults = res.discogs.slice(0, this.defaultRecordsByService);
          console.log(this.deezerArtistPictureResults);
          console.log(this.spotifyArtistPictureResults);
          console.log(this.discogsArtistPictureResults);
        })
        .catch(() => {
          this.loading = false;
          this.deezerArtistPictureResults = [];
          this.spotifyArtistPictureResults = [];
          this.discogsArtistPictureResults = [];
        });
    }
  }

  searchArtistPictureEnter(e, search) {
    e.preventDefault();
    this.searchArtistPicture(search);
  }

  selectCover(url) {
    this.dataOut.edit = true;
    this.dataOut.cover = url;
    this.dialogRef.close(this.dataOut);
  }

}
